import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconSubCategory = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 32 32" size={size}>
      <g>
        <rect fill="none" height="32" width="32">
        </rect>
      </g>
      <g>
        <polygon points="20,20 20,12 12,12 12,14 8,14 8,10 10,10 10,2 2,2 2,10 6,10 6,26 12,26 12,30 20,30 20,22 12,22 12,24.001 8,24    8,16 12,16 12,20  ">
        </polygon>
      </g>
    </BaseIcon>
  );
}

export default IconSubCategory;
